import { render, staticRenderFns } from "./indexhud.vue?vue&type=template&id=217a8ea8"
import script from "./indexhud.vue?vue&type=script&lang=js"
export * from "./indexhud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports